import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class SubcategoriesService {

    constructor(private api: ApiService) {
    }

    getList(locale: string) {
        return this.api.get(`/admin/subcategories/${locale}`).pipe(map(({result}) => result));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/subcategories.service.ts